// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1mEJdwfK1FHs5MZRCBYCV7 {\n  font-family: 'Fjalla One', sans-serif;\n  letter-spacing: 1px;\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/components/app/news/Search.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".searchInput {\n  font-family: 'Fjalla One', sans-serif;\n  letter-spacing: 1px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchInput": "_1mEJdwfK1FHs5MZRCBYCV7"
};
export default ___CSS_LOADER_EXPORT___;
